import React, { useEffect, useState } from 'react';
import message from '@web-common/components/UI/Message/SiriusMessage';
import classnames from 'classnames';
import { apiHolder as api, apis } from 'api';
import styles from './index.module.scss';
import { getIn18Text } from 'api';
const mailPraiseApi = api.api.requireLogicalApi(apis.mailPraiseApiImpl);
const contactApi = api.api.requireLogicalApi(apis.contactApiImpl);
const systemApi = api.api.getSystemApi();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const PraiseMedalItem = props => {
    var _a, _b;
    const { id, imageUrl, grayImageUrl, pendantImageUrl, name, description, count = 0, status } = props.medalData;
    const { medalWidth = 142, medalHeight = 142, containStyle } = props.styles || {};
    const { from, praiseOwner = false } = props;
    const [curPendantId, setCurPendantId] = useState('-1');
    const pendantId = (_b = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.prop) === null || _b === void 0 ? void 0 : _b.pendantId;
    useEffect(() => {
        setCurPendantId(pendantId);
    }, [pendantId]);
    const renderImage = () => {
        if (from === 'readMail' || count > 0) {
            return imageUrl;
        }
        return grayImageUrl;
    };
    const togglePendant = async () => {
        var _a, _b, _c;
        const isCurPendantId = curPendantId === String(id);
        const response = isCurPendantId ? await mailPraiseApi.cancelMedalPendant(id) : await mailPraiseApi.setMedalPendant(id);
        if (response.success) {
            message.success(isCurPendantId ? getIn18Text('TOUXIANGGUASHIYI') : getIn18Text('SHEZHICHENGGONG\uFF0C'));
            const newId = isCurPendantId ? -1 : id;
            setCurPendantId(String(newId));
            const contactId = (_c = (_b = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact) === null || _c === void 0 ? void 0 : _c.id;
            contactApi.doUpdateContactById({ id: contactId, avatarPendant: isCurPendantId ? '' : pendantImageUrl });
            mailPraiseApi.setCurrentUserPendantId(newId);
            if (from === 'readMail') {
                trackApi.track(isCurPendantId ? 'pcMail_click_readMail_praiseLetter​_medalDetails_cancelAvatarPendant' : 'pcMail_click_readMail_praiseLetter​_medalDetails_setAsAvatarPendant');
            }
            else if (from === 'contact' || from === 'other') {
                trackApi.track(isCurPendantId ? 'pcContact_click_contactsDetailPage_medalWall_setAvatarPendant' : 'pcContact_click_contactsDetailPage_medalWall_cancelAvatarPendant');
            }
        }
        else {
            message.error(isCurPendantId ? getIn18Text('QUXIAOSHIBAI\uFF0C') : getIn18Text('SHEZHISHIBAI\uFF0C'));
        }
    };
    return (React.createElement("div", { className: styles.medalItemWrap, style: Object.assign({}, containStyle) },
        React.createElement("img", { width: medalWidth, height: medalHeight, src: renderImage(), style: { display: 'inline-block' }, alt: "" }),
        React.createElement("div", { className: styles.medalName },
            name,
            count > 1 && from !== 'readMail' ? React.createElement("span", null, count) : null),
        React.createElement("div", { className: styles.desc }, description),
        praiseOwner && status === 1 ? (React.createElement("div", { className: classnames(styles.pendant, { [styles.pendantContact]: from !== 'readMail' }), onClick: togglePendant },
            curPendantId !== String(id) && React.createElement("img", { width: 30, height: 30, src: pendantImageUrl, style: { marginRight: 10 }, alt: "" }),
            curPendantId === String(id) ? getIn18Text('QUXIAO') : getIn18Text('SHEWEI'),
            getIn18Text('TOUXIANGGUASHI'))) : null));
};
export default PraiseMedalItem;
